module.exports = __webpack_public_path__ + "img/noGuanzhu.3c3c8b72.png";